import request from './request';
import moment from 'moment';

export const fetchPrimeurHeader = () =>
  request({
    method: 'GET',
    url: '/api/v1/clients/me/primeur/header/?no_page',
    protectedRoute: true,
    newApi: false
  });

export const fetchPrimeurLive = (options) =>
  request({
    method: 'GET',
    url: `/api/v1/clients/me/primeur/live/?no_page${
      options && options.date
        ? '&date=' + moment(options.date).format('YYYY-MM-DD')
        : ''
    }${options && options.vintage ? '&vintage=' + options.vintage : ''}`,
    protectedRoute: true,
    newApi: false
  });

export const fetchPrimeurRecap = (vintage) =>
  request({
    method: 'GET',
    url: `/api/v1/clients/me/primeur/recap/?no_page${
      vintage ? '&vintage=' + vintage : ''
    }`,
    protectedRoute: true,
    newApi: false
  });

export const fetchPrimeurPrepa = () =>
  request({
    method: 'GET',
    url: '/primeurs/preparation',
    protectedRoute: true,
    newApi: true
  });
